/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Secondary/view.blocks to change it.
import DiagnosisAction from './DiagnosisAction/index'
import ImagesAction from './ImagesAction/index'
import React from 'react'
import ToothChartAction from './ToothChartAction/index'



/** @type {import('Simple/types.js').View} */
export default function Secondary({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Secondary"
  
}) {
  return (<React.Fragment
>
<ToothChartAction
  viewPath={`${viewPath}/ToothChartAction`}
/>
<ImagesAction
  viewPath={`${viewPath}/ImagesAction`}
/>
<DiagnosisAction
  viewPath={`${viewPath}/DiagnosisAction`}
/>
{children}
</React.Fragment>)
}